/**
 * 库存
 * @type {{}}
 */
import Vue from "vue";
import {
  Input,
  Icon,
  Select,
  Option,
  Table,
  Page,
  Modal,
  Button,
  Switch,
  Dropdown,
  DropdownMenu, DropdownItem,
  Cascader,
  Poptip, Message,Progress,DatePicker,InputNumber
} from "view-design";
Vue.component('Input', Input);
Vue.component('Icon', Icon);
Vue.component('Select', Select);
Vue.component('Option', Option);
Vue.component('Table', Table);
Vue.component('Page', Page);
Vue.component('Modal', Modal);
Vue.component('Button', Button);
Vue.component('onSwitch', Switch);
Vue.component('Dropdown', Dropdown);
Vue.component('DropdownMenu', DropdownMenu);
Vue.component('DropdownItem', DropdownItem);
Vue.component('Cascader', Cascader);
Vue.component('Poptip', Poptip);
Vue.component('Progress', Progress);
Vue.component('DatePicker', DatePicker);
Vue.component('InputNumber', InputNumber);
import {
    getInventoryMoveService,
    getPartsListService,
    getInventoryModelAllService,
    addInventoryModelService,
    editInventoryModelService,
    delInventoryModelService,
    getInventoryManufacturerAllService,
    editPartsManufacturerService,
    addPartsManufacturerService,
    deletePartsManufacturerService,
    getInventoryWarehouseAllService,
    addPartsLocationService,
    editPartsLocationService,
    deletePartsLocationService,
    addPartsService,
    editPartsService,
    deletePartsService,
    getPartsLedgerListService,
    getPartsAllListService,
    editPartsInventory,
    editPartsVoidInventory,
    editPartsWarehousingInventory,
    editPartsOutboundInventory,
    partsColumns,
    inventory,
    ledgerColumns,
    warehousingColumns,
    outboundColumns,
} from "@/service/device-info-service";
import { inventoryUnitType } from "@/service/workflow-service";
const Inventory = {
    name:'Inventory',
    props:{
        /**
         * 设备id
         */
        equipmentId:{
            type: Number,
        },
    },
    data() {
        return {
            inventoryLoading:false,
            partsColumns:partsColumns,
            inventoryType:inventory,
            ledgerColumns:ledgerColumns,
            warehousingColumns:warehousingColumns,
            outboundColumns:outboundColumns,
            inventoryUnitType:inventoryUnitType, //单位
            tabStatus:0, // 0备件统计、1备件台账
            partsArray:[],
            partsAllArray:[],
            partsAllSelectArray:[],
            partsModelArray:[],
            deviceListHeight:0, //表格高度
            focusIndex:0,
            addInventoryVisible:false,
            partsModelVisible:false,
            manufacturerVisible:false,
            partsModalLoading:false,
            submitLoading:false,
            warehousingSubLoading:false,
            partsModelValue:'',
            partsModelSelect:[],
            partsBtnVisible:false,
            deviceAddVisible:false,
            deviceLocationAddVisible:false,
            deviceModelInfo:'',
            partsEditName:'',
            manufacturerArray:[],
            deviceFactureSelect:[],
            deviceFactureValue:'',
            deviceLocationValue:'',
            partsAllSelectValue:'',
            deviceBtnVisible:false,
            deviceLocationBtnVisible:false,
            deviceFactureInfo:false,
            deviceLocationInfo:false,
            locationArray:[],
            locationSelectArray:[],
            locationVisible:false,
            speedSingleVisible:false,
            complete:0,
            partsStatus:false,
            ledgerArray:[],
            warehousingVisible:false, //入库弹框可显示
            outboundVisible:false, //出库弹框可显示
            warehousingRecordVisible:false,
            outboundRecordVisible:false,
            warehousingRecord:{},
            outboundRecord:{},
            departmentList:[],
            accountListArray:[],
            inventoryParams:{
                name:'', //备件统计模糊查找
                currentPage: 1,  //当前页
                displayNumber:10 // 显示条数
            },
            pickerValue:'',
            ledgerParams:{
                operationType:0, //库存变化
                startDate:'', //开始时间
                endDate:'', //结束时间
                currentPage: 1,  //当前页
                displayNumber:10 // 显示条数
            },
            editParams:{
                id:'',
                name:'', //备件名称
                equipmentModelId:'', //型号id
                equipmentManufacturerId:'', //生产厂家id
                equipmentWarehouseId:'', //存放地点id
                unit:'', //计算单位
                positions:[], //安装位置
                fileRoute:'',
                fileUrl:'',
                fileName:'',
                positionsLength:0,
            },
            manufacturerParams:{ //新增生产厂家数据集
                name:'',
            },
            locationParams:{ //存放地点数据集
                name:'',
            },
            warehousingArray:[],
            outboundArray:[],
            lookPartsVisible:false,
            lookPartsArray:{},
        }
    },
    created() {
        this.onPartsListService().then()
        this.onTableHeight()
    },
    mounted() {
        window.addEventListener('resize', this.onTableHeight)
    },
    methods: {
        /**
         * 计算table高度
         */
        onTableHeight(){
            this.deviceListHeight = window.innerHeight -255
        },
        rowClassName(row){
            if(row.status === 1){
                return 'table-row-grey'
            }
        },
        /**
         * 切换统计、台账
         * @param status
         */
        onTabStatus(status){
            this.tabStatus = status
            if(status === 0){
                this.onPartsListService().then()
            }
            if(status === 1){
                this.onPartsLedgerListService().then()
            }
        },
        /**
         * 重置
         */
        onReset(){
            this.inventoryParams.name = ''
            this.onPartsListService().then()
        },
        /**
         * 重置备件台账
         */
        onResetLedger(){
            this.ledgerParams.operationType = 0
            this.ledgerParams.startDate = ''
            this.ledgerParams.endDate = ''
            this.pickerValue = ''
            this.onPartsLedgerListService().then()
        },
        /**
         * 取消
         */
        onCancel(){
            this.editParams.name = ''
            this.editParams.equipmentModelId = ''
            this.editParams.equipmentManufacturerId = ''
            this.editParams.equipmentWarehouseId = ''
            this.editParams.unit = ''
            this.editParams.positions = []
            this.editParams.fileRoute = ''
            this.editParams.fileUrl = ''
            this.editParams.fileName = ''
            this.addInventoryVisible = false
        },
        /**
         * 选择时间段
         * @param date
         */
        onChangeDate(date){
            this.ledgerParams.startDate = date[0]
            this.ledgerParams.endDate = date[1]
        },
        /**
         * 清空日期
         */
        onClearDate(){
            this.ledgerParams.startDate = ''
            this.ledgerParams.endDate = ''
        },
        /**
         * 编辑备件
         * @param row
         */
        onEditInventory(row){
            this.onInventoryModelAllService().then()
            this.onInventoryManufacturerAllService().then()
            this.onInventoryWarehouseAllService().then()
            this.partsStatus = true
            let obj = JSON.parse(JSON.stringify(row))
            this.editParams.id = obj.id
            this.editParams.name = obj.name
            this.editParams.equipmentModelId = obj.equipmentModelId
            this.editParams.equipmentManufacturerId = obj.equipmentManufacturerId
            this.editParams.equipmentWarehouseId = obj.equipmentWarehouseId
            this.editParams.unit = obj.unit
            this.editParams.positions = obj.positions
            this.editParams.positionsLength = obj.positions.length
            this.editParams.fileRoute = obj.fileRoute
            this.editParams.fileUrl = obj.fileUrl
            this.addInventoryVisible = true
        },
        /**
         * 删除备件
         * @param id
         */
        onDelInventory(id){
            Modal.confirm({
                title: '删除备件',
                content: '<p>您确定要删除这条信息吗？</p>',
                onOk: () => {
                    this.onDelPartsService(id).then()
                }
            });
        },
        /**
         * 选择备件
         * @param item
         * @param key
         */
        onWarehousingSelect(item,key){
            if(this.warehousingArray[key].sparePartsId === ''){
                this.warehousingArray[key].sparePartsId = item.id
                this.warehousingArray[key].name = item.name
                this.warehousingArray[key].equipmentWarehouseName = item.equipmentWarehouseName
                this.warehousingArray[key].num = 1
                this.warehousingArray[key].describes = ''
                this.warehousingArray[key].unit = item.unit
            }else{
                for(let i in this.partsAllSelectArray){
                    if(this.partsAllSelectArray[i].id === item.id){
                        this.warehousingArray[key].sparePartsId = this.partsAllSelectArray[i].id
                        this.warehousingArray[key].name = this.partsAllSelectArray[i].name
                        this.warehousingArray[key].equipmentWarehouseName = this.partsAllSelectArray[i].equipmentWarehouseName
                        this.warehousingArray[key].num = 1
                        this.warehousingArray[key].describes = ''
                        this.warehousingArray[key].unit = this.partsAllSelectArray[i].unit
                    }
                }
            }
            this.warehousingArray[key].visible = false
            this.partsAllSelectArray = this.partsAllArray
            this.partsAllSelectValue = ''
            this.$forceUpdate()
        },
        /**
         * 选择出库备件
         * @param item
         * @param key
         */
        onOutboundSelect(item,key){

            if(this.outboundArray[key].sparePartsId === ''){
                this.outboundArray[key].sparePartsId = item.id
                this.outboundArray[key].name = item.name
                this.outboundArray[key].repairDate = ''
                this.outboundArray[key].repairPosition = ''
                this.outboundArray[key].deptId = ''
                this.outboundArray[key].userIdList = []
                this.outboundArray[key].num = 1
                this.outboundArray[key].unit = item.unit
                this.outboundArray[key].describes = ''
                this.outboundArray[key].positions = item.positions
            }else{
                for(let i in this.partsAllSelectArray){
                    if(this.partsAllSelectArray[i].id === item.id){
                        this.outboundArray[key].sparePartsId = this.partsAllSelectArray[i].id
                        this.outboundArray[key].name = this.partsAllSelectArray[i].name
                        this.outboundArray[key].repairDate = ''
                        this.outboundArray[key].repairPosition = ''
                        // this.outboundArray[key].deptId = ''
                        this.outboundArray[key].userIdList = []
                        this.outboundArray[key].num = 1
                        this.outboundArray[key].unit = this.partsAllSelectArray[i].unit
                        this.outboundArray[key].describes = ''
                        this.outboundArray[key].positions = item.positions
                    }
                }
            }
            this.outboundArray[key].visible = false
            this.partsAllSelectArray = this.partsAllArray
            this.partsAllSelectValue = ''
            this.$forceUpdate()
        },
        /**
         * 选择部门查询检修人
         * @param key
         */
        onCascader(item,key){
            this.outboundArray[key].deptId = item[item.length-1]
            this.outboundArray[key].userIdList = []
            this.accountListArray = []
            this.onAccountListAll(item[item.length-1]).then()
        },
        onRecordCascader(item){
            this.outboundRecord.userIdList = []
            this.outboundRecord.deptId = item[item.length-1]
            this.accountListArray = []
            this.onAccountListAll(item[item.length-1]).then()
        },
        /**
         * 选择日期
         * @param item
         * @param key
         */
        onDateChange(item,key){
            this.outboundArray[key].repairDate = item
        },
        /**
         * 选择日期
         * @param item
         * @param key
         */
        onDateRecordChange(item){
            this.outboundRecord.repairDate = item
        },
        /**
         * 关闭下拉框
         */
        onPartsDownVisible(){
            for(let i in this.warehousingArray){
                this.warehousingArray[i].visible = false
            }
            this.partsAllSelectArray = this.partsAllArray
            this.partsAllSelectValue = ''
            this.$forceUpdate()
        },
        /**
         * 关闭出库下拉框
         */
        onPartsOutboundDownVisible(){
            for(let i in this.outboundArray){
                this.outboundArray[i].visible = false
            }
            this.partsAllSelectArray = this.partsAllArray
            this.partsAllSelectValue = ''
            this.$forceUpdate()
        },
        /**
         * 打开下拉框
         * @param key
         */
        onPartsDownVisibleUp(key){
            for(let i in this.warehousingArray){
                this.warehousingArray[i].visible = false
            }
            this.warehousingArray[key].visible = true
            this.$forceUpdate()
        },
        /**
         * 打开出库下拉框
         * @param key
         */
        onPartsOutboundDownVisibleUp(key){
            for(let i in this.outboundArray){
                this.outboundArray[i].visible = false
            }
            this.outboundArray[key].visible = true
            this.$forceUpdate()
        },
        /**
         * 创建出库记录
         */
        onAddOutboundRecord(){
            console.log(this.outboundArray)
            if(this.outboundArray.length === 0){
                this.outboundArray.push({
                    name:'',
                    sparePartsId:'',
                    repairDate:'',
                    repairPosition:'',
                    deptId:'',
                    userIdList:[],
                    num:1,
                    unit:'',
                    describes:'',
                    positions:[],
                    visible:false,
                })
            }else{
                let repairPartsIdRegular = this.outboundArray.some(item =>{
                    if(item.sparePartsId === ''){
                        return true
                    }
                })
                if(repairPartsIdRegular){
                    Message.warning('请选择备件！')
                    return;
                }
                let repairDateRegular = this.outboundArray.some(item =>{
                    if(item.repairDate === ''){
                        return true
                    }
                })
                if(repairDateRegular){
                    Message.warning('请选择检修日期！')
                    return;
                }
                let repairPositionRegular = this.outboundArray.some(item =>{
                    if(item.repairPosition === '' || item.repairPosition === undefined){
                        return true
                    }
                })
                if(repairPositionRegular){
                    Message.warning('请选择检修位置！')
                    return
                }
                let deptIdRegular = this.outboundArray.some(item =>{
                    if(item.deptId === ''){
                        return true
                    }
                })
                if(deptIdRegular){
                    Message.warning('请选择检修部门！')
                    return
                }
                let userIdListRegular = this.outboundArray.some(item =>{
                    if(item.userIdList.length === 0){
                        return true
                    }
                })
                if(userIdListRegular){
                    Message.warning('请选择检修人！')
                    return
                }
                this.outboundArray.push({
                    name:'',
                    sparePartsId:'',
                    repairDate:'',
                    repairPosition:'',
                    deptId:'',
                    userIdList:[],
                    num:1,
                    unit:'',
                    describes:'',
                    positions:[],
                    visible:false,
                })
            }
            this.$forceUpdate()
        },
        /**
         * 创建入库记录
         */
        onAddRecord(){
            if(this.warehousingArray.length === 0){
                this.warehousingArray.push({
                    name:'',
                    sparePartsId:'',
                    equipmentWarehouseName:'',
                    num:1,
                    describes:'',
                    unit:'',
                    visible:false,
                })
            }else{
                let partsIdRegular = this.warehousingArray.some(item =>{
                    if(item.sparePartsId === ''){
                        return true
                    }
                })
                if(partsIdRegular){
                    Message.warning('请选择备件！')
                }else{
                    this.warehousingArray.push({
                        name:'',
                        sparePartsId:'',
                        equipmentWarehouseName:'',
                        num:1,
                        describes:'',
                        unit:'',
                        visible:false,
                    })
                }
            }
            this.$forceUpdate()
        },
        /**
         * 作废
         * @param id
         */
        onVoid(id){
            Modal.confirm({
                title: '提示',
                content: '<p>确定要作废这条记录吗？</p>',
                onOk: () => {
                    this.onEditPartsVoidInventory(id).then()
                },
            });
        },
        /**
         * 编辑出入库
         * @param item
         */
        onEditRecord(item){
            if(item.operationType === 1){
                this.warehousingRecordVisible = true;
                this.warehousingRecord = JSON.parse(JSON.stringify(item))
            }
            if(item.operationType === 2){
                console.log(item)
                this.onAccountListAll(item.deptId).then(()=>{
                    this.outboundRecord = JSON.parse(JSON.stringify(item))
                })
                this.onUserDeptMenuList().then()
                this.outboundRecordVisible = true
            }
            this.$forceUpdate()
        },
        /**
         * 查看出入库
         * @param item
         */
        onLookRecord(item){
            this.lookPartsArray = item
            if(item.describes === ''){
                this.lookPartsArray.describes = '无'
            }
            this.lookPartsVisible = true
        },

        /**
         * 取消入库
         */
        onWarehousingCancel(){
            this.warehousingArray = []
            this.warehousingVisible = false
        },
        /**
         * 取消出库
         */
        onOutboundCancel(){
            this.outboundArray = []
            this.outboundVisible = false
        },
        /**
         * 入库弹框发生变化时
         * @param status
         */
        onWarehousingVisibleChange(status){
            if(!status && !this.partsModalLoading){
                this.onWarehousingCancel()
            }
        },
        /**
         * 出库弹框发生变化时
         * @param status
         */
        onOutboundVisibleChange(status){
            if(!status && !this.partsModalLoading){
                this.onOutboundCancel()
            }
        },
        /**
         * 删除入库记录
         * @param key
         */
        onDeleteWarehousing(key){
            this.warehousingArray.splice(key,1)
        },
        /**
         * 删除出库库记录
         * @param key
         */
        onDeleteOutbound(key){
            this.outboundArray.splice(key,1)
        },
        /**
         * 发送当前页
         * @param number
         */
        onSearchPage(number){
            this.inventoryParams.currentPage = number
            this.onPartsListService().then()
        },
        /**
         * 发送每页显示的条数
         * @param number
         */
        onSearchPageSize(number){
            this.inventoryParams.displayNumber = number
            this.onPartsListService().then()
        },
        /**
         * 发送台账当前页
         * @param number
         */
        onSearchLedgerPage(number){
            this.ledgerParams.currentPage = number
            this.onPartsLedgerListService().then()
        },
        /**
         * 发送台账每页显示的条数
         * @param number
         */
        onSearchLedgerPageSize(number){
            this.ledgerParams.displayNumber = number
            this.onPartsLedgerListService().then()
        },
        /**
         * 弹框发生变化时
         * @param status
         */
        onVisibleChange(status){
            if(!status){
                this.onCancel()
            }
        },
        /**
         * 提交验证
         */
        onAddInventoryCheck(){
            if(this.editParams.name === ''){
                Message.warning('请输入备件名！')
                return
            }
            if(this.editParams.equipmentModelId === ''){
                Message.warning('请选择型号！')
                return
            }
            if(this.editParams.equipmentManufacturerId === ''){
                Message.warning('请选择厂家！')
                return
            }
            if(this.editParams.equipmentWarehouseId === ''){
                Message.warning('请选择存放地点！')
                return
            }
            if(this.editParams.unit === ''){
                Message.warning('请选择单位！')
                return
            }
            let resultRegular = this.editParams.positions.some(item =>{
                if(item === ''){
                    return true
                }
            })
            if(this.editParams.positions.length === 0 || resultRegular){
                Message.warning('请填写安装位置！')
                return
            }
            !this.partsStatus?this.onAddPartsService().then():this.onEditPartsService().then()
        },
        /**
         * 验证入库记录
         * @param item
         */
        onAddWarehousingRecordCheck(){
            this.onEditPartsWarehousingInventory().then()
        },
        /**
         * 验证出库记录
         * @param item
         */
        onAddOutboundRecordCheck(){
            if(this.outboundRecord.userIdList.length === 0){
                Message.warning('请选择检修人！')
                return
            }
            if(this.outboundRecord.repairDate === '' || this.outboundRecord.repairDate === null){
                Message.warning('请选择检修日期！')
                return
            }
            this.onEditPartsOutboundInventory().then()
        },
        /**
         * 清空
         * @param type
         */
        onClearImage() {
            this.editParams.fileRoute = ''
            this.editParams.fileUrl = ''
        },
        /**
         * 查询备件统计
         */
        onSearch(){
            this.onPartsListService().then()
        },
        /**
         * 查询备件台账
         */
        onSearchLedger(){
            this.onPartsLedgerListService().then()
        },
        /**
         * 查询入库备件列表
         */
        onWarehousing(){
            this.warehousingVisible = true
            this.onPartsAllListService().then(()=>{
                this.partsModalLoading = false
            })
        },
        /**
         * 查询出库备件列表
         */
        onOutboundVisible(){
            this.outboundVisible = true
            this.onPartsAllListService().then(()=>{
                this.onUserDeptMenuList().then(()=>{
                    this.partsModalLoading = false
                })
            })
        },
        /**
         * 添加安装位置
         */
        onAddLocation(){
            let resultRegular = this.editParams.positions.some(item =>{
                if(item === ''){
                    return true
                }
            })
            if(resultRegular){
                Message.warning('请添写位置！')
                return
            }
            this.editParams.positions.push('')
        },
        /**
         * 删除位置
         * @param key
         */
        onLocationClose(key){
            this.editParams.positions.splice(key,1)
        },
        /**
         * 统计列表移动排序
         * @param id
         * @param type
         */
        onSortableFault(id,type){
            this.onInventoryMoveService(id,type).then()
        },
        /**
         * 新增备件
         */
        onAddList(){
            this.partsStatus = false
            this.editParams.positionsLength = 0
            this.onInventoryModelAllService().then()
            this.onInventoryManufacturerAllService().then()
            this.onInventoryWarehouseAllService().then()
            this.addInventoryVisible = true
        },
        /**
         * 点击型号弹框关闭状态
         * @param status
         */
        onModelVisibleChange(status){
            if(!status){
                this.onDeviceModalResetting()
                this.partsEditName = ''
                this.deviceAddVisible = false
            }
        },
        /**
         * 型号重置
         */
        onDeviceModalResetting() {
            this.partsModelValue = ''
            this.partsModelSelect = this.partsModelArray
            for(let i in this.partsModelSelect){
                this.partsModelSelect[i].visible = true
            }
            this.partsBtnVisible = false
            this.$forceUpdate()
        },
        /**
         * 搜索型号
         */
        onDeviceModalSearch() {
            if(this.partsModelValue === ''){
                this.partsModelSelect = this.partsModelArray
                this.partsBtnVisible = false
                return
            }
            this.partsModelSelect = this.onFilter(this.partsModelArray,this.partsModelValue)
            this.partsBtnVisible = true
            this.deviceAddVisible = false
            this.partsEditName = ''
        },
        /**
         * 过滤列表相同名称
         * @param array
         * @param content
         * @returns {*[]}
         */
        onFilter(array,content){
            return array.filter((value)=>{  //过滤数组元素
                return value.name.includes(content); //如果包含字符返回true
            });
        },
        /**
         * 过滤列表相同名称
         * @param array
         * @param content
         * @returns {*[]}
         */
        onFilterParts(array,content){
            return array.filter((value)=>{  //过滤数组元素
                return value.name.includes(content) || value.equipmentModelName.includes(content) || value.equipmentManufacturerName.includes(content) || value.equipmentWarehouseName.includes(content); //如果包含字符返回true
            });
        },
        /**
         * 新增备件型号
         */
        onPartsAddModel(){
            this.deviceAddVisible = true
            for(let i in this.partsModelSelect){
                this.partsModelSelect[i].visible = true
            }
            this.deviceModelInfo = ''
            this.$nextTick(()=>{
                let deviceList = document.getElementById('deviceList')
                deviceList.scrollTop = (this.partsModelArray.length+1)*42-273
            })
        },
        /**
         * 新增备件型号验证
         */
        onDeviceModelCheck(){
            if(this.partsEditName === ''){
                Message.warning('请输入备件型号！')
                return
            }
            if(this.partsModelSelect.some((item)=>{ return item.name === this.partsEditName })){
                Message.warning('信息重复，请重新输入！')
                return
            }
            // if(this.deviceParams.manufacturer.length === 0){
            //     Message.error('请选择生产厂家！')
            //     return
            // }
            this.onAddInventoryModelService().then()
        },
        /**
         * 验证备件型号
         * @param key
         */
        onDeviceModelEditCheck(key) {
            if(this.deviceModelInfo === ''){
                Message.warning('请输入备件型号')
                return
            }
            if(this.partsModelSelect.some((item)=>{ return item.name === this.deviceModelInfo})){
                Message.warning('信息重复，请重新输入！')
                return
            }
            this.onEditInventoryModelService(this.partsModelSelect[key].id).then()
        },
        /**
         * 编辑备件型号
         * @param key
         */
        onDeviceModalEdit(key){
            for(let i in this.partsModelSelect){
                this.partsModelSelect[i].visible = true
            }
            this.deviceModelInfo = this.partsModelSelect[key].name
            this.partsModelSelect[key].visible? this.partsModelSelect[key].visible = false : this.partsModelSelect[key].visible = true
            this.deviceAddVisible = false
            this.partsEditName = ''
            this.$forceUpdate()
        },
        /**
         * 删除备件型号
         * @param key
         */
        onDeviceModalDel(key) {
            this.onDelInventoryModelService(this.partsModelSelect[key].id).then()
        },
        /**
         * 关闭备件操作
         * @param key
         */
        onDeviceModalClose(key){
            this.partsModelSelect[key].visible? this.partsModelSelect[key].visible = false : this.partsModelSelect[key].visible = true
            this.deviceModelInfo = ''
            this.$forceUpdate()
        },
        /**
         * 厂家重置
         */
        onDeviceFactureResetting() {
            this.deviceFactureValue = ''
            this.deviceFactureSelect = this.manufacturerArray
            for(let i in this.deviceFactureSelect){
                this.deviceFactureSelect[i].visible = true
            }
            this.deviceBtnVisible = false
            this.$forceUpdate()
        },
        /**
         * 存放地点重置
         */
        onDeviceLocationResetting() {
            this.deviceLocationValue = ''
            this.locationSelectArray = this.locationArray
            for(let i in this.locationSelectArray){
                this.locationSelectArray[i].visible = true
            }
            this.deviceLocationBtnVisible = false
            this.$forceUpdate()
        },
        /**
         * 搜索厂家
         */
        onDeviceFactureSearch() {
            if(this.deviceFactureValue === ''){
                this.deviceFactureSelect = this.manufacturerArray
                this.deviceBtnVisible = false
                return
            }
            this.deviceFactureSelect = this.onFilter(this.manufacturerArray,this.deviceFactureValue)
            this.deviceBtnVisible = true
            this.deviceAddVisible = false
            this.manufacturerParams.name= ''
        },
        /**
         * 搜索存放地点
         */
        onDeviceLocationSearch() {
            if(this.deviceLocationValue === ''){
                this.locationSelectArray = this.locationArray
                this.deviceLocationBtnVisible = false
                return
            }
            this.locationSelectArray = this.onFilter(this.locationArray,this.deviceLocationValue)
            this.deviceLocationBtnVisible = true
            this.deviceLocationAddVisible = false
            this.locationParams.name= ''
        },
        /**
         * 搜索存放地点
         */
        onPartsAllSearch() {
            if(this.partsAllSelectValue === ''){
                this.partsAllSelectArray = this.partsAllArray
                return
            }
            this.partsAllSelectArray = this.onFilterParts(this.partsAllArray,this.partsAllSelectValue)
        },
        /**
         * 编辑厂家
         * @param key
         */
        onDeviceFactureEdit(key){
            for(let i in this.deviceFactureSelect){
                this.deviceFactureSelect[i].visible = true
            }
            this.deviceFactureInfo = this.deviceFactureSelect[key].name
            this.deviceFactureSelect[key].visible? this.deviceFactureSelect[key].visible = false : this.deviceFactureSelect[key].visible = true
            this.deviceAddVisible = false
            this.manufacturerParams.name= ''
            this.$forceUpdate()
        },
        /**
         * 编辑存放地点
         * @param key
         */
        onDeviceLocationEdit(key){
            for(let i in this.locationSelectArray){
                this.locationSelectArray[i].visible = true
            }
            this.deviceLocationInfo = this.locationSelectArray[key].name
            this.locationSelectArray[key].visible? this.locationSelectArray[key].visible = false : this.locationSelectArray[key].visible = true
            this.deviceLocationAddVisible = false
            this.locationParams.name= ''
            this.$forceUpdate()
        },
        /**
         * 编辑厂家验证
         * @param key
         */
        onDeviceFactureEditCheck(key) {
            if(this.deviceFactureInfo === ''){
                Message.warning('请输入生产厂家')
                return
            }
            if(this.deviceFactureSelect.some((item)=>{ return item.name === this.deviceFactureInfo})){
                Message.warning('信息重复，请重新输入！')
                return
            }
            this.onEditPartsManufacturerService(this.deviceFactureSelect[key].id).then()
        },
        /**
         * 编辑存放地点验证
         * @param key
         */
        onDeviceLocationEditCheck(key) {
            if(this.deviceLocationInfo === ''){
                Message.warning('请输入存放地点')
                return
            }
            if(this.locationSelectArray.some((item)=>{ return item.name === this.deviceLocationInfo})){
                Message.warning('信息重复，请重新输入！')
                return
            }
            this.onEditPartsLocationService(this.locationSelectArray[key].id).then()
        },
        /**
         * 新增厂家
         */
        onDeviceAddFacture() {
            this.deviceAddVisible = true
            for(let i in this.deviceFactureSelect){
                this.deviceFactureSelect[i].visible = true
            }
            this.deviceFactureInfo = ''
            this.$nextTick(()=>{
                let deviceList = document.getElementById('deviceFactureList')
                deviceList.scrollTop = (this.manufacturerArray.length+1)*42-273
            })
        },
        /**
         * 新增存放地点
         */
        onDeviceAddLocation() {
            this.deviceLocationAddVisible = true
            for(let i in this.locationSelectArray){
                this.locationSelectArray[i].visible = true
            }
            this.deviceLocationInfo = ''
            this.$nextTick(()=>{
                let deviceList = document.getElementById('deviceLocationList')
                deviceList.scrollTop = (this.locationArray.length+1)*42-273
            })
        },
        /**
         * 新增生产厂家验证
         */
        onDeviceFactureCheck(){
            if(this.manufacturerParams.name === ''){
                Message.warning('请输入生产厂家！')
                return
            }
            if(this.deviceFactureSelect.some((item)=>{ return item.name === this.manufacturerParams.name })){
                Message.warning('信息重复，请重新输入！')
                return
            }
            // if(this.deviceParams.manufacturer.length === 0){
            //     Message.error('请选择生产厂家！')
            //     return
            // }
            this.onAddPartsManufacturerService().then()
        },
        /**
         * 新增存放地点验证
         */
        onDeviceLocationCheck(){
            if(this.locationParams.name === ''){
                Message.warning('请输入存放地点！')
                return
            }
            if(this.locationSelectArray.some((item)=>{ return item.name === this.locationParams.name })){
                Message.warning('信息重复，请重新输入！')
                return
            }
            // if(this.deviceParams.manufacturer.length === 0){
            //     Message.error('请选择生产厂家！')
            //     return
            // }
            this.onAddPartsLocationService().then()
        },
        /**
         * 关闭修改厂家
         * @param key
         */
        onDeviceFactureClose(key){
            this.deviceFactureSelect[key].visible? this.deviceFactureSelect[key].visible = false : this.deviceFactureSelect[key].visible = true
            this.deviceFactureInfo = ''
            this.$forceUpdate()
        },
        /**
         * 关闭存放地点
         * @param key
         */
        onDeviceLocationClose(key){
            this.locationSelectArray[key].visible? this.locationSelectArray[key].visible = false : this.locationSelectArray[key].visible = true
            this.deviceLocationInfo = ''
            this.$forceUpdate()
        },
        /**
         * 删除备件厂家
         * @param key
         */
        onDeviceFactureDel(key) {
            this.onDelPartsManufacturerService(this.deviceFactureSelect[key].id).then()
        },
        /**
         * 删除存放地点
         * @param key
         */
        onDeviceLocationDel(key) {
            this.onDelPartsLocationService(this.locationSelectArray[key].id).then()
        },
        /**
         * 点击厂家弹框关闭状态
         * @param status
         */
        onFactureVisibleChange(status){
            if(!status){
                this.onDeviceFactureResetting()
                this.manufacturerParams.name= ''
                this.deviceAddVisible = false
            }
        },
        /**
         * 统计列表数据查询
         */
        async onPartsListService() {
            try {
                this.inventoryLoading = true
                let params = {
                    equipmentId:this.equipmentId,
                    name:this.inventoryParams.name,
                    displayNumber:this.inventoryParams.displayNumber,
                    currentPage:this.inventoryParams.currentPage
                }
                const { code,data } = await getPartsListService(params)
                if(code === 'SUCCESS'){
                    this.partsArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.inventoryLoading = false
            }catch (error){
                this.inventoryLoading = false
                console.log(error)
            }
        },
        /**
         * 统计列表数据查询不分页
         */
        async onPartsAllListService() {
            try {
                this.partsModalLoading = true
                let params = {
                    equipmentId:this.equipmentId,
                }
                const { code,data } = await getPartsAllListService(params)
                if(code === 'SUCCESS'){
                    this.partsAllArray = data
                    this.partsAllSelectArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                this.partsModalLoading = false
                console.log(error)
            }
        },
        /**
         * 故障分析移动排序
         */
        async onInventoryMoveService(id,moveType) {
            try {
                let params = {
                    id:id,
                    moveType:moveType,
                }
                const { code } = await getInventoryMoveService(params)
                if(code === 'SUCCESS'){
                    this.onPartsListService().then()
                }else{
                  Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 备件型号列表
         */
        async onInventoryModelAllService() {
            try {
                let params = {}
                const { code,data } = await getInventoryModelAllService(params)
                if(code === 'SUCCESS'){
                    this.partsModelArray = data
                    this.partsModelSelect = data
                    for(let i in this.partsModelSelect){
                        this.partsModelSelect[i].visible = true
                    }
                }else{
                  Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 新增备件型号
         */
        async onAddInventoryModelService() {
            try {
                this.submitLoading = true
                let params = {
                    name:this.partsEditName,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await addInventoryModelService(params)
                if(code === 'SUCCESS'){
                    Message.success('添加成功')
                    this.deviceAddVisible = false
                    this.partsEditName = ''
                    this.onInventoryModelAllService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 编辑备件型号
         */
        async onEditInventoryModelService(id) {
            try {
                this.submitLoading = true
                let params = {
                    name:this.deviceModelInfo,
                    id:id,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await editInventoryModelService(params)
                if(code === 'SUCCESS'){
                    Message.success('修改成功')
                    this.partsEditName = ''
                    this.onDeviceModalResetting()
                    this.onInventoryModelAllService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 删除设备型号
         */
        async onDelInventoryModelService(id) {
            try {
                this.submitLoading = true
                let params = {
                    id:id,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await delInventoryModelService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功')
                    this.onInventoryModelAllService().then()
                }else if(code === 'EQUIPMENT_MANUFACTURER_MODEL_DELETE_FAIL_LINKED_DATA_EXISTS'){
                    Message.error('此型号已被引用，不可删除！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 备件生产厂家列表
         */
        async onInventoryManufacturerAllService() {
            try {
                let params = {}
                const { code,data } = await getInventoryManufacturerAllService(params)
                if(code === 'SUCCESS'){
                    this.manufacturerArray = data
                    this.deviceFactureSelect = data
                    for(let i in this.deviceFactureSelect){
                        this.deviceFactureSelect[i].visible = true
                    }
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 编辑生产厂家
         */
        async onEditPartsManufacturerService(id) {
            try {
                this.submitLoading = true
                let params = {
                    name:this.deviceFactureInfo,
                    id:id,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await editPartsManufacturerService(params)
                if(code === 'SUCCESS'){
                    Message.success('修改成功')
                    this.deviceFactureInfo = ''
                    this.onDeviceFactureResetting()
                    this.onInventoryManufacturerAllService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 编辑存放地点
         */
        async onEditPartsLocationService(id) {
            try {
                this.submitLoading = true
                let params = {
                    name:this.deviceLocationInfo,
                    id:id,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await editPartsLocationService(params)
                if(code === 'SUCCESS'){
                    Message.success('修改成功')
                    this.deviceLocationInfo = ''
                    this.onDeviceLocationResetting()
                    this.onInventoryWarehouseAllService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 添加生产厂家
         */
        async onAddPartsManufacturerService() {
            try {
                this.submitLoading = true
                let params = {
                    name:this.manufacturerParams.name
                }
                const { code } = await addPartsManufacturerService(params)
                if(code === 'SUCCESS'){
                    Message.success('添加成功')
                    this.deviceAddVisible = false
                    this.manufacturerParams.name = ''
                    this.onInventoryManufacturerAllService().then()
                }else if(code === 'EQUIPMENT_MANUFACTURER_REPEAT_NAME'){
                    Message.error('添加的生产厂家重复！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 添加存放地点
         */
        async onAddPartsLocationService() {
            try {
                this.submitLoading = true
                let params = {
                    name:this.locationParams.name
                }
                const { code } = await addPartsLocationService(params)
                if(code === 'SUCCESS'){
                    Message.success('添加成功')
                    this.deviceLocationAddVisible = false
                    this.locationParams.name = ''
                    this.onInventoryWarehouseAllService().then()
                }else if(code === 'EQUIPMENT_WAREHOUSE_REPEAT_NAME'){
                    Message.error('添加的存放地点重复！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 删除备件厂家
         */
        async onDelPartsManufacturerService(id) {
            try {
                this.submitLoading = true
                let params = {
                    id:id,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await deletePartsManufacturerService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功')
                    this.onInventoryManufacturerAllService().then()
                }else if(code === 'EQUIPMENT_MANUFACTURER_DELETE_FAIL_LINKED_DATA_EXISTS'){
                    Message.error('此厂家已被引用，不可删除！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 删除存放地点
         */
        async onDelPartsLocationService(id) {
            try {
                this.submitLoading = true
                let params = {
                    id:id,
                    // manufacturerIds:this.deviceParams.manufacturer
                }
                const { code } = await deletePartsLocationService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功')
                    this.onInventoryWarehouseAllService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 备件存放地点列表
         */
        async onInventoryWarehouseAllService() {
            try {
                let params = {}
                const { code,data } = await getInventoryWarehouseAllService(params)
                if(code === 'SUCCESS'){
                    this.locationArray = data
                    this.locationSelectArray = data
                    for(let i in this.locationSelectArray){
                        this.locationSelectArray[i].visible = true
                    }
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
        /**
         * 添加备件
         */
        async onAddPartsService() {
            try {
                this.submitLoading = true
                let params = {
                    equipmentId:this.equipmentId,
                    name:this.editParams.name,
                    equipmentModelId:this.editParams.equipmentModelId,
                    equipmentManufacturerId:this.editParams.equipmentManufacturerId,
                    equipmentWarehouseId:this.editParams.equipmentWarehouseId,
                    unit:this.editParams.unit,
                    positions:this.editParams.positions,
                    fileRoute:this.editParams.fileRoute,
                }
                const { code } = await addPartsService(params)
                if(code === 'SUCCESS'){
                    Message.success('添加成功')
                    this.addInventoryVisible = false
                    this.onPartsListService().then()
                }else if(code === 'EQUIPMENT_SPARE_PARTS_NAME_REPEAT'){
                    Message.warning('备件名称、型号、厂家、存放地点不可重复')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 编辑备件
         */
        async onEditPartsService() {
            try {
                this.submitLoading = true
                let params = {
                    id:this.editParams.id,
                    name:this.editParams.name,
                    equipmentModelId:this.editParams.equipmentModelId,
                    equipmentManufacturerId:this.editParams.equipmentManufacturerId,
                    equipmentWarehouseId:this.editParams.equipmentWarehouseId,
                    unit:this.editParams.unit,
                    positions:this.editParams.positions,
                    fileRoute:this.editParams.fileRoute,
                }
                const { code } = await editPartsService(params)
                if(code === 'SUCCESS'){
                    Message.success('修改成功')
                    this.addInventoryVisible = false
                    this.onPartsListService().then()
                }else if(code === 'EQUIPMENT_SPARE_PARTS_NAME_REPEAT'){
                    Message.warning('备件名称、型号、厂家、存放地点不可重复')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 删除备件
         */
        async onDelPartsService(id) {
            try {
                this.submitLoading = true
                let params = {
                    id:id,
                }
                const { code } = await deletePartsService(params)
                if(code === 'SUCCESS'){
                    Message.success('删除成功')
                    this.onPartsListService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 台账列表数据查询
         */
        async onPartsLedgerListService() {
            try {
                this.inventoryLoading = true
                let params = {
                    equipmentId:this.equipmentId,
                    startDate:this.ledgerParams.startDate,
                    endDate:this.ledgerParams.endDate,
                    operationType:this.ledgerParams.operationType === 0?'':this.ledgerParams.operationType,
                    displayNumber:this.ledgerParams.displayNumber,
                    currentPage:this.ledgerParams.currentPage
                }
                const { code,data } = await getPartsLedgerListService(params)
                if(code === 'SUCCESS'){
                    this.ledgerArray = data
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.inventoryLoading = false
            }catch (error){
                this.inventoryLoading = false
                console.log(error)
            }
        },
        /**
         * 编辑出入库
         */
        async onEditPartsInventory(type) {
            try {
                this.warehousingSubLoading = true
                let params = {}
                if(type === 1){
                     params = {
                        equipmentId:this.equipmentId,
                        operationType:type,
                        detailList:this.warehousingArray
                    }
                }
                if(type === 2){
                    params = {
                        equipmentId:this.equipmentId,
                        operationType:type,
                        detailList:this.outboundArray
                    }
                }
                const { code } = await editPartsInventory(params)
                if(code === 'SUCCESS'){
                    Message.success('提交成功！');
                    if(type === 1){
                        this.warehousingVisible = false
                    }
                    if(type === 2){
                        this.outboundVisible = false
                    }
                    this.onPartsLedgerListService().then()
                }else if(code === 'EQUIPMENT_SPARE_PARTS_INVENTORY_LACK'){
                    Message.error('出库量不可超过库存！')
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.warehousingSubLoading = false
            }catch (error){
                this.warehousingSubLoading = false
                console.log(error)
            }
        },
        /**
         * 编辑入库
         */
        async onEditPartsWarehousingInventory() {
            try {
                this.submitLoading = true
                let params = {
                    id:this.warehousingRecord.id,
                    describes:this.warehousingRecord.describes,
                }
                const { code } = await editPartsWarehousingInventory(params)
                if(code === 'SUCCESS'){
                    Message.success('提交成功！');
                    this.warehousingRecordVisible = false
                    this.onPartsLedgerListService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 编辑出库
         */
        async onEditPartsOutboundInventory() {
            try {
                this.submitLoading = true
                let params = {
                    id:this.outboundRecord.id,
                    describes:this.outboundRecord.describes,
                    repairPosition:this.outboundRecord.repairPosition,
                    repairDate:this.outboundRecord.repairDate,
                    deptId:this.outboundRecord.deptId,
                    userIdList:this.outboundRecord.userIdList,

                }
                const { code } = await editPartsOutboundInventory(params)
                if(code === 'SUCCESS'){
                    Message.success('提交成功！');
                    this.outboundRecordVisible = false
                    this.onPartsLedgerListService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
                this.submitLoading = false
            }catch (error){
                this.submitLoading = false
                console.log(error)
            }
        },
        /**
         * 替换属性名
         * @param data
         */
        onReplaceAttribute(data){
            let item = []
            data.map(list => {
                let newData = {}
                newData.value = list.id;
                newData.label = list.name;
                newData.visible = list.visible;
                newData.children = list.childNode;
                newData.checked = list.checked;
                newData.icon = list.icon;
                newData.parentId = list.parentId;
                if(list.childNode){
                    newData.children = this.onReplaceAttribute(list.childNode)
                }
                item.push(newData)
            })
            return item
        },
        /**
         * 作废出入库记录
         */
        async onEditPartsVoidInventory(id) {
            try {
                let params = {
                    id:id,
                }
                const { code } = await editPartsVoidInventory(params)
                if(code === 'SUCCESS'){
                    Message.success('已作废！')
                    this.onPartsLedgerListService().then()
                }else{
                    Message.error('请求异常，请联系管理员！')
                }
            }catch (error){
                console.log(error)
            }
        },
    },
    destroyed () {
        window.removeEventListener('resize',this.onTableHeight)
    }
}
export default Inventory
